<template>
  <section class="min-h-[calc(100vh-48px)] bg-sky-900 flex items-center">
    <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
      
      <!-- Left: Text -->
      <div class="text-white hero-fade">
        <h1 class="text-4xl sm:text-5xl font-bold mb-6 text-white leading-tight mt-2">
          <span class="bg-gradient-to-r from-sky-500/20 to-transparent px-2 py-1 rounded-tl-md block w-fit">
            Code the Edge.
          </span>
          <span class="bg-gradient-to-r from-sky-500/20 to-transparent px-2 py-1 rounded-tr-md rounded-br-md block w-fit">
            Trade the Future.
          </span>
        </h1>
        <p class="text-lg sm:text-xl mb-12">
          Hey 👋 I’m Egbert — a trader and developer who helps traders bring their strategies to life through smart MQL5 automation.
        </p>
        <a
          href="https://t.me/egbertjoel"
          target="_blank"
          class="mt-6 px-6 py-3 rounded-lg bg-black text-white font-semibold border border-white hover:bg-white hover:text-black transition duration-300"
        >
          Book a Free Consult
        </a>
      </div>

      <!-- Right: Your Photo -->
      <div class="flex justify-center hero-fade delay">
        <img :src="pilotImage" alt="AlgoPilot" class="rounded-2xl shadow-2xl max-h-[500px] w-auto object-cover" />
      </div>

    </div>
  </section>
</template>

<script>
import pilotImage from "@/assets/Profile-polished.png";

export default {
  name: "HeroComp",
  data() {
    return {
      pilotImage,
    };
  },
};
</script>

<style scoped>
@keyframes hero-fade-in-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-fade {
  animation: hero-fade-in-up 0.8s ease-out forwards;
  opacity: 0; /* fallback for animation-less environments */
}

.delay {
  animation-delay: 0.2s;
}
</style>
